import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { getCohortsFn } from "../APIServices/Services";
import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../ui/Spinner";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';

function Teams() {
  const { data, isError, error, isLoading } = useQuery(
    ["cohorts"],
    getCohortsFn
  );
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Spinner />
        </Container>
      </Box>
    );
  }
  if (isError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            Oops, something went wrong
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {error.toString()}
          </Typography>
        </Container>
      </Box>
    );
  }
  if (data.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            No Cohorts added yet!
          </Typography>
        </Container>
      </Box>
    );
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
        <Typography component="h1" variant="h4" gutterBottom>
          Cohorts
        </Typography>
        {data.map((cohort, index) => (
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            key={index}
            style={{ marginTop: 4, top: 20 }}
          >
            <Card sx={{ maxWidth: 345 }}>
              <CardMedia
                component="img"
                height="140"
                image={cohort.image}
                alt={cohort.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {cohort.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {cohort.body}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small">Share</Button>
                <Button size="small">Learn More</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Teams;
